<template>
  <div class="learnDefault conten column cen-start">
    <span class="ilbk learnImg text-center">
        <img src="../../assets/imgs/unCoupon.png" alt="">
    </span>
    <p class="ft15 gray-0 margin20-top">来晚了，券已领完啦~~</p>
    <p class="ft12 gray-6 margin50-top">去首页看看其他优惠课程吧</p>
    <span @click="goHome" class="btn text-center ilbk ft16 white">回到首页</span>
  </div>
</template>

<script>
export default {
  name: 'learnDefault',
  data(){
      return {

      }
  },
  methods: {
      goHome(){
          this.$router.push({
              path: '/index'
          })
      }
  }
}
</script>
<style scoped lang="less">
.learnDefault{
    width: 100%;
    padding-top: 54/20rem;
    .learnImg{
        width: 151/20rem;
        height: 73/20rem;
    }
    .text{
        padding-top:38/20rem
    }
    .btn{
        margin-top:1.5rem;
        width:130/20rem;
        height:38/20rem;
        line-height:38/20rem;
        background:linear-gradient(90deg,rgba(253,123,49,1),rgba(240,130,67,1));
        box-shadow:0px 0px 7/20rem 3px rgba(253,123,49,0.43);
        border-radius:19/20rem;
    }
}
</style>
